module.exports = __webpack_public_path__ + "static/media/w-2_24.00173549.png";